module KendoWidgets
{
	export class DialogOptions implements kendo.ui.DialogOptions
	{
		buttons: DialogButton[];
		content?: string;
		height?: number | string;
		modal?: boolean | kendo.ui.DialogModal;
		visible?: boolean;
		width?: number | string;
		textAlign?: DialogTextAlignEnum;

		close?(e: kendo.ui.DialogCloseEvent): void;
		hide?(e: kendo.ui.DialogEvent): void;
		open?(e: kendo.ui.DialogEvent): void;
	}

	export class Dialog extends kendo.ui.Dialog implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.Dialog; }

		constructor(element: Element, options?: KendoWidgets.DialogOptions)
		{
			if (options == null)
				options = new KendoWidgets.DialogOptions();

			//#region Default options
			if (options.buttons == null) options.buttons = [];
			//#endregion

			//#region Buttons
			(options as any).actions = [];
			for (let button of options.buttons)
			{
				if (button.noClose == null)
					button.noClose = false;

				(options as any).actions.push(
					{
						text: button.text,
						action: (e: any) =>
						{
							if (button.click != null)
							{
								let clickEvent = new DialogButtonClickEvent();
								clickEvent.button = button;
								clickEvent.sender = e.sender;
								button.click(clickEvent);
							}
							return !button.noClose;
						},
						primary: button.isPrimary
					});
			}
			//#endregion

			super(element, options);
			let that = this;

			//#region Text align
			if (options.textAlign != null)
			{
				switch (options.textAlign)
				{
					case DialogTextAlignEnum.Left: this.element.parent().css("text-align", "left"); break;
					case DialogTextAlignEnum.Center: this.element.parent().css("text-align", "center"); break;
					case DialogTextAlignEnum.Right: this.element.parent().css("text-align", "right"); break;
				}
			}
			//#endregion
		}

		remove()
		{
			this.destroy();
			this.element.parent().remove();
		}
	}

	Dialog.fn = Dialog.prototype;
	Dialog.fn.options = $.extend(true, {}, kendo.ui.Dialog.fn.options);
	Dialog.fn.options.name = "Dialog";
	kendo.ui.plugin(Dialog);

	export class DialogButton
	{
		text: string;
		isPrimary?: boolean;
		click?(e: DialogButtonClickEvent): void;
		noClose?: boolean;
	}

	export class DialogButtonClickEvent
	{
		sender: KendoWidgets.Dialog;
		button: KendoWidgets.DialogButton;
	}

	export enum DialogTextAlignEnum
	{
		Left,
		Center,
		Right
	}
}

interface JQuery
{
	kendoDialog(options?: KendoWidgets.DialogOptions): JQuery;
}